import styled from 'react-emotion';
import { space, color } from 'styled-system';

export const InputWrapper = styled('section')`
  display: flex;
  flex-direction: ${props => props.inline ? 'row' : 'column'};
  font-family: 'proxima-nova', sans-serif;
  line-height: 1.2;
  ${space}
  ${color}

  label {
    letter-spacing: 1px;
    cursor: pointer;
  }

  input {
    border: 0;
    border-bottom: 2px solid #aaa;
    transition: border-color 0.25s ease-in-out;
    font-size: 1.25em;
    &:focus {
      outline: 0;
      border-bottom: 2px solid ${props => props.theme.colors.clientPrimary};
    }
  }

  .ant-switch {
    width: 4em;

    &.ant-switch-checked {
      background: ${props => props.theme.colors.clientPrimary};
    }
    .ant-click-animating-node {
      border-color: ${props => props.theme.colors.clientPrimary};
    }
  }
`;

export const FieldDescription = styled('i')`
  ${space}
  font-size: 0.75em;
`;
